@if (!formType) {
  <div class="alert alert-warning mb-0">Choose the employee type to open the matching appraisal form.</div>
} @else {
  <div class="appraisal-head">
    <div class="appraisal-kicker">Physio Life performance appraisal</div>
    <h5 class="mb-1">{{ formLabel }}</h5>
    <p class="mb-2 text-muted small">Quarterly appraisal, covering three months.</p>
    @if (staffName) {
      <div class="staff-name">Staff name: <strong>{{ staffName }}</strong></div>
    }
    <div class="month-row" aria-label="Appraisal months">
      @for (month of months; track month; let i = $index) {
        <span class="month-chip" [class.active]="monthActive(i)">{{ month }}</span>
      }
    </div>
    @if (year && quarter) {
      <div class="small text-muted mt-2">{{ year }} · Q{{ quarter }}</div>
    }
  </div>

  @if (scale.length) {
    <div class="scale-legend">
      @for (item of scale; track item.value) {
        <span><strong>{{ item.value }}</strong> {{ item.label }}</span>
      }
    </div>
  }

  @for (group of groupedFields; track group.section) {
    <section class="form-section">
      <h6 class="section-title">{{ group.section }}</h6>
      @for (field of group.fields; track field.key) {
        <div class="criterion">
          <label class="criterion-title" [attr.for]="'eval-' + field.key">
            {{ field.label }}
            @if (field.required) {
              <span class="text-danger">*</span>
            }
          </label>
          @if (field.bullets?.length) {
            <ul class="bullets">
              @for (bullet of field.bullets; track bullet) {
                <li>{{ bullet }}</li>
              }
            </ul>
          }

          @switch (field.type) {
            @case ('textarea') {
              <textarea
                class="form-control"
                rows="2"
                [id]="'eval-' + field.key"
                [name]="field.key"
                [(ngModel)]="answers[field.key]"
                [readonly]="viewOnly"
              ></textarea>
            }
            @case ('date') {
              <input
                type="date"
                class="form-control"
                [id]="'eval-' + field.key"
                [name]="field.key"
                [(ngModel)]="answers[field.key]"
                [readonly]="viewOnly"
              />
            }
            @case ('rating') {
              @if (field.options?.length) {
                <div class="option-list">
                  @for (option of field.options; track option.value) {
                    <label class="option-item" [class.selected]="isSelected(field, option.value)">
                      <input
                        type="radio"
                        [name]="'eval-' + field.key"
                        [checked]="isSelected(field, option.value)"
                        [disabled]="viewOnly"
                        (change)="setRating(field.key, +option.value)"
                      />
                      <span><strong>{{ option.value }}.</strong> {{ option.label }}</span>
                    </label>
                  }
                </div>
              } @else {
                <div class="btn-group btn-group-sm rating-group" role="group" [attr.aria-label]="field.label">
                  @for (item of scale; track item.value) {
                    <button
                      type="button"
                      class="btn"
                      [class.btn-primary]="isSelected(field, item.value)"
                      [class.btn-outline-secondary]="!isSelected(field, item.value)"
                      [disabled]="viewOnly"
                      [title]="item.label"
                      (click)="setRating(field.key, item.value)"
                    >
                      {{ item.value }}
                    </button>
                  }
                </div>
              }
            }
            @default {
              <input
                type="text"
                class="form-control"
                [id]="'eval-' + field.key"
                [name]="field.key"
                [(ngModel)]="answers[field.key]"
                [readonly]="viewOnly"
              />
            }
          }
        </div>
      }

      @if (group.section === 'Criteria') {
        <div class="score-box">
          @if (score.complete) {
            <div class="score-line"><span>Sum</span><strong>{{ score.sum }}</strong></div>
            <div class="score-line">
              <span>Result</span>
              <strong>{{ score.sum }} / {{ score.max }} × 100 = {{ score.percentLabel }}%</strong>
            </div>
            <div class="score-line"><span>Ranking</span><strong>{{ score.rank }}</strong></div>
          } @else {
            <div class="score-line">
              <span>Progress</span>
              <strong>{{ score.rated }} / {{ score.total }} criteria rated</strong>
            </div>
            <p class="mb-0 small text-muted">The result is calculated when every criterion has a score.</p>
          }
        </div>
        @if (legend.length) {
          <div class="overall-legend">
            <div class="section-title">Overall performance</div>
            @for (item of legend; track item.score) {
              <div class="legend-row">
                <span class="legend-score">{{ item.score }}</span>
                <span>
                  <strong>{{ item.title }}.</strong>
                  {{ item.text }}
                </span>
              </div>
            }
          </div>
        }
      }
    </section>
  }

  <div class="signature-row">
    <div>
      <div class="small text-muted">Staff signature</div>
      <strong>{{ staffName || 'Staff' }}</strong>
      <div class="small text-muted">Recorded when the form is submitted.</div>
    </div>
    <div>
      <div class="small text-muted">PHL administration</div>
      <strong>{{ status === 'approved' ? 'Approved' : 'Pending review' }}</strong>
      <div class="small text-muted">Recorded when the admin approves the appraisal.</div>
    </div>
  </div>
}
